/** สถานะจัดส่งเรียบร้อย ไม่ต้องกันสต็อกและไม่ต้องล็อกแถว */
export const PROCESS_STATUS_KEY_SHIPPED = 'SHIPPED';

export const STOCK_ROW_STATE = {
  OK: 'OK', // ของพอ เลือกได้
  OVER_SELECTED: 'OVER_SELECTED', // ของพอ แต่ที่ติ๊กไว้รวมกันเกิน
  OUT_OF_STOCK: 'OUT_OF_STOCK', // ของไม่พอตั้งแต่แรก
  UNKNOWN: 'UNKNOWN', // ไม่เจอ itemId ใน snapshot
  STALE: 'STALE', // ข้อมูลสต็อกเก่าเกินกำหนด
  EXCLUDED: 'EXCLUDED', // จัดส่งเรียบร้อยแล้ว ไม่นับ
};

/** class ที่ใช้ทาสีแถว (นิยามใน styles.js) */
export const STOCK_ROW_CLASS = {
  [STOCK_ROW_STATE.OVER_SELECTED]: 'stock-row-danger',
  [STOCK_ROW_STATE.OUT_OF_STOCK]: 'stock-row-danger',
  [STOCK_ROW_STATE.UNKNOWN]: 'stock-row-warning',
  [STOCK_ROW_STATE.STALE]: 'stock-row-warning',
};
